import React from "react";

const isChunkError = (e) => /ChunkLoadError|Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(String(e?.name || "") + " " + String(e?.message || ""));

/* Never a blank screen: after a deploy the cached app may point at old files (chunk 404) — clear caches and reload once; any other crash shows a Reload button. */
export class AppErrorBoundary extends React.Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err) {
    if (isChunkError(err) && !sessionStorage.getItem("rl_chunk_reload")) {
      sessionStorage.setItem("rl_chunk_reload", String(Date.now()));
      AppErrorBoundary.hardReload();
    }
  }
  static async hardReload() {
    try { if ("caches" in window) { const keys = await caches.keys(); await Promise.all(keys.filter((k) => !k.includes("shared-receipt")).map((k) => caches.delete(k))); } } catch {}
    try { const regs = await navigator.serviceWorker?.getRegistrations?.(); await Promise.all((regs || []).map((r) => r.update().catch(() => {}))); } catch {}
    window.location.reload();
  }
  render() {
    if (!this.state.err) return this.props.children;
    const chunk = isChunkError(this.state.err);
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center" style={{ background: "#0b0b0f", color: "#f8e7b0" }} data-testid="app-error-screen">
        <div className="max-w-xs w-full">
          <div className="text-4xl mb-3">👑</div>
          <div className="font-black text-lg">{chunk ? "புதிய update வந்திருக்கு" : "ஒரு சின்ன பிரச்சனை"}</div>
          <div className="text-sm opacity-80 mt-1">{chunk ? "App-ஐ refresh பண்ணினா சரியாகிடும்." : "Refresh பண்ணி மறுபடி முயற்சிக்கவும்."}</div>
          <button onClick={() => { sessionStorage.removeItem("rl_chunk_reload"); AppErrorBoundary.hardReload(); }} className="mt-5 w-full rounded-2xl py-3 font-black text-slate-900" style={{ background: "linear-gradient(120deg,#f5d061,#d4af37)" }} data-testid="app-error-reload">Refresh / புதுப்பி</button>
        </div>
      </div>
    );
  }
}

// Lazy chunks that fail to load (old build after a deploy) → one automatic hard reload instead of a blank page.
export const lazyRetry = (factory) => React.lazy(() => factory().catch((e) => {
  if (isChunkError(e) && !sessionStorage.getItem("rl_chunk_reload")) {
    sessionStorage.setItem("rl_chunk_reload", String(Date.now()));
    AppErrorBoundary.hardReload();
    return new Promise(() => {});
  }
  throw e;
}));
